<template>
    <div class="bgf8">
        <div class="p20" v-if="isMobile">
            <div class="list mb20" @click="nav('/detail5')">
                <div class="flex itc mb10">
                    <div class="flex_1 title">在职职工意外伤害互助保障</div>
                    <div class="el-icon-arrow-right c9"></div>
                </div>
                <div class="desc">伤残互助金住院补助互助金待遇全面提高</div>
            </div>
            <div class="list mb20" @click="nav('/detail6')">
                <div class="flex itc mb10">
                    <div class="flex_1 title">在职职工子女意外伤害互助保障</div>
                    <div class="el-icon-arrow-right c9"></div>
                </div>
                <div class="desc">关注健康成长互助温暖相伴</div>
            </div>
            <div class="list mb20" @click="nav('/detail7')">
                <div class="flex itc mb10">
                    <div class="flex_1 title">在职职工短期意外伤害互助保障</div>
                    <div class="el-icon-arrow-right c9"></div>
                </div>
                <div class="desc">囊括10日内意外身故、残疾及意外伤害医疗费用保障</div>
            </div>
            <div class="list mb20" @click="nav('/detail8')">
                <div class="flex itc mb10">
                    <div class="flex_1 title">在职职工意外伤害互助保障(D款)</div>
                    <div class="el-icon-arrow-right c9"></div>
                </div>
                <div class="desc">囊括1年內意外身故、残疾及意外伤害医疗費用保障</div>
            </div>
        </div>
        <!-- pc 端 -->
        <div class="" v-else>
            <img src="../../assets/special/db5_pc.jpg" alt="" class="mobileImg">
            <div class="special_box">
                <backSpecial></backSpecial>

                <div class="flex juc ">

                    <div class="flex_1 pc_list trans hover_blue" @click="nav('/detail5')">
                        <div class="flex itc mb20 blue">
                            <div class="flex_1">
                                <div class="title">在职职工意外伤害互助保障</div>
                            </div>
                            <div class="triangle">
                                <div class="el-icon-caret-right fz20"></div>
                            </div>
                        </div>
                        <div class="fz14">伤残互助金住院补助互助金待遇全面提高</div>
                    </div>
                    <div class="interval"></div>
                    <div class="flex_1 pc_list trans hover_green" @click="nav('/detail6')">
                        <div class="flex itc mb20 green">
                            <div class="flex_1">
                                <div class="title">在职职工子女意外伤害互助保障</div>
                            </div>
                            <div class="triangle">
                                <div class="el-icon-caret-right fz20"></div>
                            </div>
                        </div>
                        <div class="fz14">关注健康成长互助温暖相伴</div>
                    </div>
                    <div class="interval"></div>
                    <div class="flex_1 pc_list trans hover_blue" @click="nav('/detail7')">
                        <div class="flex itc mb20 blue">
                            <div class="flex_1">
                                <div class="title">在职职工短期意外伤害互助保障</div>
                            </div>
                            <div class="triangle">
                                <div class="el-icon-caret-right fz20"></div>
                            </div>
                        </div>
                        <div class="fz14">囊括10日内意外身故、残疾及意外伤害医疗费用保障</div>
                    </div>
                    <div class="interval"></div>
                    <div class="flex_1 pc_list trans hover_green" @click="nav('/detail8')">
                        <div class="flex itc mb20 green">
                            <div class="flex_1">
                                <div class="title">在职职工意外伤害互助保障(D款)</div>
                            </div>
                            <div class="triangle">
                                <div class="el-icon-caret-right fz20"></div>
                            </div>
                        </div>
                        <div class="fz14">囊括1年內意外身故、残疾及意外伤害医疗費用保障</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Mixins from "../../script/getMobile";
import backSpecial from "@/components/backSpecial.vue"
export default {
    name: "",
    mixins: [Mixins],
    data() {
        return {

        }
    },
    created() {

    },
    components: {
        backSpecial
    },
    methods: {
        nav(url) {
            if (url) {
                if (url.indexOf('http') > -1) {
                    location.href = url;
                } else {
                    this.$router.push(url)
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.special_box {
    padding: 20px 20px;
    max-width: 1200px;
    margin: auto;

    .title {
        font-size: 26px;
    }

    .pc_list {
        border-radius: 10px;
        background-color: #efefef;
        padding: 20px;
        cursor: pointer;
    }

    .interval {
        width: 10px;
    }

    .blue {
        color: #0059b3;
    }

    .green {
        color: #008c02;
    }

    .hover_blue:hover {
        background-color: #0059b3;

        .blue {
            color: #fff;
        }

        .fz14 {
            color: #fff;
        }
    }

    .hover_green:hover {
        background-color: #008c02;

        .green {
            color: #fff;
        }

        .fz14 {
            color: #fff;
        }
    }
}

.bgf8 {
    background-color: #f8f8f8;
    width: 100%;
    height: 100vh;
}

.list {
    border-radius: 5px;
    overflow: hidden;
    background: url(../../assets/special/sbg.jpg) no-repeat center / cover;
    padding: 20px;
}

.title {
    font-size: 18px;
    font-weight: bold;
}

.desc {
    font-size: 14px;
    color: #666;
}
</style>